<template>
    <el-select
        v-model="txtSelectStatusList"
        class="checkbox-in-select">
        <el-option disabled value="ทั้งหมด">
            <el-checkbox
                v-model="isCheckStatusAll"
                :indeterminate="isIndeterminate"
                @change="handleCheckAllChange">
                ทั้งหมด
            </el-checkbox>
        </el-option>
        <el-option v-for="(item, index) in itemList" :key="`key-${index}`" disabled :value="index">
            <el-checkbox-group v-model="selectList" @change="handleSelectStatusListChange">
                <el-checkbox :label="item.value">{{item.label}}</el-checkbox>
            </el-checkbox-group>
        </el-option>
    </el-select>
</template>

<script>
export default {
    name: 'MultipleCheckboxInSelect',
    props: {
        constantList: {
            type: Array,
            default: () => []
        },
        itemList: {
            type: Array,
            default: () => []
        },
        maxLength: {
            type: Number,
            default: 0
        },
        objectKey: {
            type: Object,
            default: () => {}
        },
        isClear: {
            type: Boolean,
            default: false
        },
        isCreatecomponent: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            isIndeterminate: true,
            isCheckStatusAll: true,
            selectList: [],
            txtSelectStatusList: '0 ตัวเลือก'
        }
    },
    mounted () {
        this.selectList = this.constantList
        this.conditionSelection()
        this.$emit('selectList', this.selectList)
    },
    watch: {
        isClear: {
            deep: true,
            async handler (val) {
                if (val) {
                    this.selectList = this.constantList
                    this.conditionSelection()
                    this.isIndeterminate = true
                    this.isCheckStatusAll = true
                    this.$emit('selectList', this.selectList)
                    this.$emit('clearSelect', false)
                }
            }
        },
        isCreatecomponent (val) {
            if (val) {
                this.selectList = this.constantList
                this.$emit('selectList', this.selectList)
            }
        }
    },
    methods: {
        handleCheckAllChange (val) {
            this.selectList = val ? this.constantList : []
            this.$emit('selectList', this.selectList)
            this.isIndeterminate = false
            this.conditionSelection()
        },
        handleSelectStatusListChange (value) {
            const checkedCount = value.length
            this.isCheckStatusAll = checkedCount === this.itemList.length
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.itemList.length
            this.$emit('selectList', this.selectList)
            this.conditionSelection()
        },
        conditionSelection () {
            if (this.selectList.length === this.maxLength) {
                this.txtSelectStatusList = 'ทั้งหมด'
            } else if (this.selectList.length === 1) {
                this.txtSelectStatusList = this.objectKey[this.selectList[0]]
            } else if (this.selectList.length > 1 && this.selectList.length < this.maxLength) {
                this.txtSelectStatusList = `${this.selectList.length} รายการ`
            } else {
                this.txtSelectStatusList = '0 ตัวเลือก'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.checkbox-in-select {
    width: 100%;
}
::v-deep .el-checkbox__inner {
    width: 20px;
    height: 20px;
}
::v-deep .el-checkbox__inner::after {
    height: 10px;
    left: 6px;
    width: 5px;
}
::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
    top: 8px;
}
::v-deep .el-select-dropdown__item.hover {
    background-color: unset;
}
</style>
